import { useContext, useEffect } from "react";

import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";

import { Link, useNavigate } from "react-router-dom";

import { Button } from "@evos/components";
import { useKeycloak } from "@react-keycloak/web";

import logo from "assets/images/logo.png";
import "./login.css";
import { AuthContext } from "lib/context/auth";

export default function Login() {
  const navigate = useNavigate();
  const { keycloak, initialized } = useKeycloak();
  const auth = useContext(AuthContext);

  useEffect(() => {
    if (!initialized) {
      return;
    }

    if (keycloak?.authenticated === true && auth?.user != null) {
      navigate("/", { replace: true });
    }
  }, [auth?.user, initialized, keycloak?.authenticated, navigate]);

  const handleLogin = () => {
    keycloak?.login({ redirectUri: window.location.origin + "/" });
  };

  return (
    <div className="Login text-center">
      <div style={{width: "100%"}}>
        <Card className="form-signin shadow">
          <Link to="/login"><Image className="my-4 mx-auto d-block" src={logo} alt="" width="180" /></Link>
          <h1 className="h3 mb-4 fw-normal text-black">Monitoring Dashboard</h1>
          <Button
            variant="primary"
            className="mb-3 me-2 w-100"
            onClick={handleLogin}
          >
            Sign in
          </Button>
        </Card>
      </div>
    </div>
  );
}
